import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import { AgilityImage } from "@agility/gatsby-image-agilitycms"
import { parseISO, format } from "date-fns";


const NewestBlogPosts = ({ module }) => {

    const data = useStaticQuery(graphql`
        query {
            allAgilityPost(limit: 3, sort: {order: DESC, fields: customFields___date}) {
              nodes {
                customFields {
                  title
                  image {
                    url
                    width
                    height
                    label
                  }
                  date
                }
                sitemapNode {
                    path
                }
              }
            }
        }
    `)

    const newestPosts = data.allAgilityPost.nodes
    const imgScale = module.customFields.scaleImageOnHover === 'true';
    if (!newestPosts || newestPosts.length < 3) {
        return <></>
    }

    return (
        <section className="newest-blog-posts w-full mx-auto max-w-screen-xl py-28">
            <h2 className="col-span-2 text-center mb-20">{module.customFields.title}</h2>
            <div className="w-full grid lg:grid-cols-2 gap-y-5 gap-x-14 items-stretch">
                <div className="lg:row-span-2">
                    <Link to={newestPosts[0].sitemapNode?.path ?? ""} className="text-body-text">
                        <AgilityImage
                            image={newestPosts[0].customFields.image}
                            layout="fullWidth"
                            style={{
                                width: "100%",
                                height: "836px"
                            }}
                            imgClassName={`object-cover ${imgScale ? '!transition !duration-300 hover:!scale-110' : ''}`}
                        />
                        <div className="font-bold uppercase leading-6 tracking-widest mt-5">{newestPosts[0].customFields.title}</div>
                        <div className="leading-6 tracking-wider mt-5">{format(parseISO(newestPosts[0].customFields.date), 'MMMM do, yyyy')}</div>
                    </Link>
                </div>
                <div>
                    <Link to={newestPosts[1].sitemapNode?.path ?? ""} className="text-body-text">
                        <AgilityImage
                            image={newestPosts[1].customFields.image}
                            layout="fullWidth"
                            style={{
                                width: "100%",
                                height: "350px"
                            }}
                            imgClassName={`object-cover ${imgScale ? '!transition !duration-300 hover:!scale-110' : ''}`}
                        />
                        <div className="font-bold uppercase leading-6 tracking-widest mt-5">{newestPosts[1].customFields.title}</div>
                        <div className="leading-6 tracking-wider mt-5">{format(parseISO(newestPosts[1].customFields.date), 'MMMM do, yyyy')}</div>
                    </Link>
                </div>
                <div>
                    <Link to={newestPosts[2].sitemapNode?.path ?? ""} className="text-body-text">
                        <AgilityImage
                            image={newestPosts[2].customFields.image}
                            layout="fullWidth"
                            style={{
                                width: "100%",
                                height: "350px"
                            }}
                            imgClassName={`object-cover ${imgScale ? '!transition !duration-300 hover:!scale-110' : ''}`}
                        />
                        <div className="font-bold uppercase leading-6 tracking-widest mt-5">{newestPosts[2].customFields.title}</div>
                        <div className="leading-6 tracking-wider mt-5">{format(parseISO(newestPosts[2].customFields.date), 'MMMM do, yyyy')}</div>
                    </Link>
                </div>
            </div>
        </section>
    )

}

export default NewestBlogPosts